export const allProperties = [
  {
    id: 1,
    tag: 'VENDA',
    location: 'Chapecó/SC - Bairro Jardim Itália',
    title: 'Casa à venda',
    bedrooms: 3,
    bathrooms: 2,
    parking: 2,
    area: 120,
    price: 'R$ 850.000,00',
    priceValue: 850000,
    image: 'https://readdy.ai/api/search-image?query=Modern%20single-story%20residential%20house%20with%20landscaped%20garden%2C%20clean%20minimalist%20architecture%2C%20warm%20natural%20lighting%2C%20suburban%20Brazilian%20neighborhood%20setting%2C%20high%20quality%20real%20estate%20photography%2C%20professional%20listing%20photo&width=600&height=400&seq=prop-01&orientation=landscape',
    description: 'Uma excelente opção para quem busca conforto, espaço e praticidade em Chapecó. A casa possui 120m² de área construída, distribuídos em 3 quartos, 2 banheiros e ambientes pensados para a rotina familiar. A garagem comporta 2 veículos, enquanto o quintal espaçoso amplia as possibilidades de convivência, lazer e aproveitamento ao ar livre. Localizada no bairro Jardim Itália, fica em uma região tranquila e com fácil acesso a escolas, mercados e estabelecimentos comerciais. Um imóvel acolhedor, adequado para famílias que desejam morar bem e ter os principais serviços por perto.',
    type: 'Casa',
    purpose: 'Venda',
    city: 'Chapecó',
  },
  {
    id: 2,
    tag: 'VENDA',
    location: 'Chapecó/SC - Centro',
    title: 'Apartamento à venda',
    bedrooms: 2,
    bathrooms: 2,
    parking: 1,
    area: 95,
    price: 'R$ 620.000,00',
    priceValue: 620000,
    image: 'https://readdy.ai/api/search-image?query=Modern%20apartment%20interior%20living%20room%20with%20open%20plan%20kitchen%2C%20contemporary%20furniture%2C%20large%20windows%20with%20natural%20light%2C%20warm%20neutral%20tones%2C%20Brazilian%20city%20view%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-02&orientation=landscape',
    description: 'Apartamento moderno e funcional para quem deseja aproveitar toda a conveniência de morar no centro de Chapecó. Com 95m², o imóvel oferece 2 dormitórios, 2 banheiros e uma distribuição confortável para a rotina de casais ou pequenas famílias. Conta ainda com 1 vaga de garagem e está inserido em um condomínio com elevador, salão de festas e segurança 24 horas. A localização facilita o acesso a restaurantes, comércio, serviços, transporte público e opções de lazer. É uma oportunidade interessante tanto para moradia quanto para quem procura um imóvel bem localizado para investir.',
    type: 'Apartamento',
    purpose: 'Venda',
    city: 'Chapecó',
  },
  {
    id: 3,
    tag: 'LOCAÇÃO',
    location: 'Xanxerê/SC - Bairro Colatto',
    title: 'Casa para alugar',
    bedrooms: 2,
    bathrooms: 1,
    parking: 1,
    area: 70,
    price: 'R$ 2.200,00/mês',
    priceValue: 2200,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20two-story%20family%20house%20with%20small%20front%20yard%2C%20white%20exterior%20walls%2C%20red%20roof%20tiles%2C%20residential%20Brazilian%20street%20setting%2C%20warm%20afternoon%20lighting%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-03&orientation=landscape',
    description: 'Casa aconchegante para locação no bairro Colatto, em Xanxerê, ideal para quem procura tranquilidade e uma rotina prática. São 70m² bem aproveitados, com 2 quartos, 1 banheiro e ambientes adequados para casais ou pequenas famílias. O imóvel também dispõe de 1 vaga de garagem, trazendo mais comodidade e segurança no dia a dia. A região possui perfil residencial, ambiente familiar e boa vizinhança. É uma alternativa equilibrada para quem deseja morar em um bairro tranquilo sem abrir mão do acesso aos serviços da cidade. A locação pode ser realizada mediante fiador ou caução.',
    type: 'Casa',
    purpose: 'Locação',
    city: 'Xanxerê',
  },
  {
    id: 4,
    tag: 'VENDA',
    location: 'São Miguel do Oeste/SC - Centro',
    title: 'Terreno à venda',
    bedrooms: 0,
    bathrooms: 0,
    parking: 0,
    area: 450,
    price: 'R$ 320.000,00',
    priceValue: 320000,
    image: 'https://readdy.ai/api/search-image?query=Flat%20green%20land%20plot%20ready%20for%20construction%2C%20fenced%20area%2C%20trees%20in%20background%2C%20suburban%20Brazilian%20setting%2C%20clear%20blue%20sky%2C%20professional%20real%20estate%20photography%2C%20development%20opportunity&width=600&height=400&seq=prop-04&orientation=landscape',
    description: 'Terreno com 450m² localizado na região central de São Miguel do Oeste, oferecendo uma base versátil para diferentes projetos. A área plana favorece o planejamento e a execução da obra, seja para uma residência, empreendimento comercial ou investimento imobiliário. Sua localização permite acesso rápido às principais avenidas, ao comércio e aos serviços essenciais da cidade. A documentação encontra-se regularizada, proporcionando mais segurança e agilidade durante a negociação. Uma oportunidade para quem procura um lote bem posicionado, pronto para construir e com potencial de valorização em uma das principais cidades do Extremo Oeste Catarinense.',
    type: 'Terreno',
    purpose: 'Venda',
    city: 'São Miguel do Oeste',
  },
  {
    id: 5,
    tag: 'VENDA',
    location: 'Chapecó/SC - Bairro Efapi',
    title: 'Casa à venda',
    bedrooms: 4,
    bathrooms: 3,
    parking: 2,
    area: 210,
    price: 'R$ 1.250.000,00',
    priceValue: 1250000,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20modern%20two-story%20house%20with%20swimming%20pool%20and%20garden%2C%20large%20glass%20windows%2C%20contemporary%20architecture%2C%20warm%20evening%20lighting%2C%20upscale%20Brazilian%20residential%20neighborhood%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-05&orientation=landscape',
    description: 'Residência de alto padrão projetada para oferecer amplitude, privacidade e momentos especiais em família. Com 210m², possui 4 dormitórios, 3 banheiros e espaços integrados que valorizam o conforto e a convivência. A área externa conta com piscina e ambiente gourmet, criando o cenário ideal para receber amigos e aproveitar os dias de descanso. São 2 vagas de garagem e acabamento de primeira linha, acompanhando uma proposta arquitetônica moderna. Localizada em condomínio fechado no bairro Efapi, a propriedade oferece portaria 24 horas e uma rotina mais segura para quem busca exclusividade sem se afastar das facilidades de Chapecó.',
    type: 'Casa',
    purpose: 'Venda',
    city: 'Chapecó',
  },
  {
    id: 6,
    tag: 'LOCAÇÃO',
    location: 'Chapecó/SC - Centro',
    title: 'Apartamento para alugar',
    bedrooms: 1,
    bathrooms: 1,
    parking: 1,
    area: 55,
    price: 'R$ 1.500,00/mês',
    priceValue: 1500,
    image: 'https://readdy.ai/api/search-image?query=Compact%20modern%20studio%20apartment%20with%20minimalist%20decor%2C%20single%20room%20with%20bed%20and%20small%20kitchen%2C%20large%20window%20with%20city%20view%2C%20clean%20white%20walls%2C%20Brazilian%20urban%20apartment%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-06&orientation=landscape',
    description: 'Apartamento compacto, moderno e muito bem localizado no centro de Chapecó. Seus 55m² foram aproveitados de forma funcional, oferecendo 1 dormitório, 1 banheiro e ambientes adequados para uma rotina prática e organizada. O imóvel conta com 1 vaga de garagem e está situado em um prédio novo com elevador, agregando conforto e acessibilidade. A posição central permite realizar muitas atividades do cotidiano com facilidade, mantendo comércio, serviços, restaurantes e transporte próximos. É uma ótima alternativa para estudantes, profissionais ou casais que desejam morar com conveniência e mobilidade em uma das áreas mais valorizadas da cidade.',
    type: 'Apartamento',
    purpose: 'Locação',
    city: 'Chapecó',
  },
  {
    id: 7,
    tag: 'VENDA',
    location: 'Xanxerê/SC - Centro',
    title: 'Sala Comercial à venda',
    bedrooms: 0,
    bathrooms: 1,
    parking: 1,
    area: 65,
    price: 'R$ 280.000,00',
    priceValue: 280000,
    image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20office%20space%20with%20reception%20desk%2C%20glass%20partitions%2C%20fluorescent%20lighting%2C%20clean%20white%20interior%2C%20professional%20business%20environment%2C%20Brazilian%20commercial%20building%2C%20real%20estate%20photography&width=600&height=400&seq=prop-07&orientation=landscape',
    description: 'Sala comercial com 65m² em localização estratégica no centro de Xanxerê, preparada para receber diferentes tipos de atividade profissional. O espaço pode ser adaptado para escritórios, consultórios, atendimento ao público ou operações comerciais, oferecendo flexibilidade para o desenvolvimento do seu negócio. Possui 1 banheiro e 1 vaga, além de estar em um edifício comercial com elevador e estacionamento rotativo. A região central facilita o acesso de clientes, colaboradores e fornecedores, além de proporcionar proximidade com bancos, comércio e serviços. Uma opção consistente para empreendedores ou investidores que procuram visibilidade, praticidade e potencial de valorização.',
    type: 'Sala Comercial',
    purpose: 'Venda',
    city: 'Xanxerê',
  },
  {
    id: 8,
    tag: 'VENDA',
    location: 'Maravilha/SC - Zona Rural',
    title: 'Chácara à venda',
    bedrooms: 3,
    bathrooms: 2,
    parking: 4,
    area: 5000,
    price: 'R$ 680.000,00',
    priceValue: 680000,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20country%20house%20chacara%20with%20large%20green%20lawn%2C%20fruit%20trees%2C%20rustic%20wooden%20fence%2C%20red%20roof%2C%20surrounded%20by%20nature%2C%20peaceful%20Brazilian%20countryside%2C%20warm%20sunny%20day%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-08&orientation=landscape',
    description: 'Chácara com 5.000m² na zona rural de Maravilha, perfeita para quem deseja mais espaço, contato com a natureza e tranquilidade. A propriedade possui uma casa com 3 quartos, 2 banheiros e estrutura confortável para moradia permanente ou lazer nos finais de semana. O terreno dispõe de pomar, horta e área com potencial para criação de animais, permitindo aproveitar diferentes atividades rurais. Há disponibilidade de energia elétrica e água, além de espaço para até 4 veículos. Uma oportunidade para famílias que buscam qualidade de vida, privacidade e a liberdade de viver em uma propriedade ampla no Oeste Catarinense.',
    type: 'Chácara',
    purpose: 'Venda',
    city: 'Maravilha',
  },
  {
    id: 9,
    tag: 'LOCAÇÃO',
    location: 'Chapecó/SC - Bairro Country',
    title: 'Casa para alugar',
    bedrooms: 3,
    bathrooms: 2,
    parking: 2,
    area: 140,
    price: 'R$ 3.500,00/mês',
    priceValue: 3500,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20suburban%20family%20home%20with%20manicured%20lawn%20and%20mature%20trees%2C%20brick%20and%20stucco%20exterior%2C%20covered%20porch%2C%20residential%20Brazilian%20neighborhood%2C%20warm%20golden%20hour%20lighting%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-09&orientation=landscape',
    description: 'Casa espaçosa para locação no bairro Country, em Chapecó, indicada para famílias que valorizam conforto e uma localização residencial. O imóvel possui 140m², com 3 dormitórios, 2 banheiros e ambientes que oferecem boa circulação para as atividades do dia a dia. A garagem coberta acomoda 2 veículos, garantindo praticidade e proteção. A proximidade com parques e escolas contribui para uma rotina familiar mais simples, com opções de lazer e serviços essenciais nas redondezas. É uma residência equilibrada para quem precisa de espaço, deseja morar em um bairro agradável e busca facilidade de acesso a diferentes pontos da cidade.',
    type: 'Casa',
    purpose: 'Locação',
    city: 'Chapecó',
  },
  {
    id: 10,
    tag: 'VENDA',
    location: 'Palmitos/SC - Centro',
    title: 'Terreno à venda',
    bedrooms: 0,
    bathrooms: 0,
    parking: 0,
    area: 300,
    price: 'R$ 195.000,00',
    priceValue: 195000,
    image: 'https://readdy.ai/api/search-image?query=Empty%20urban%20construction%20lot%20with%20dirt%20ground%2C%20street%20view%2C%20residential%20houses%20in%20background%2C%20Brazilian%20small%20town%20setting%2C%20clear%20daylight%2C%20real%20estate%20development%20opportunity%2C%20professional%20photography&width=600&height=400&seq=prop-10&orientation=landscape',
    description: 'Terreno urbano com 300m² disponível para venda no centro de Palmitos. Localizado em rua calçada e próximo ao comércio e aos principais serviços da cidade, o lote oferece praticidade para futuros moradores e boa visibilidade para diferentes projetos. Sua metragem permite planejar uma residência funcional ou avaliar outras possibilidades de construção de acordo com as normas municipais. A documentação está regularizada, trazendo mais segurança para a negociação e para o início do planejamento da obra. Uma oportunidade interessante para construir, investir ou formar patrimônio em uma região consolidada, com infraestrutura urbana e potencial de valorização.',
    type: 'Terreno',
    purpose: 'Venda',
    city: 'Palmitos',
  },
  {
    id: 11,
    tag: 'VENDA',
    location: 'Chapecó/SC - Bairro Passo dos Fortes',
    title: 'Apartamento à venda',
    bedrooms: 3,
    bathrooms: 2,
    parking: 1,
    area: 110,
    price: 'R$ 720.000,00',
    priceValue: 720000,
    image: 'https://readdy.ai/api/search-image?query=Spacious%20modern%20apartment%20balcony%20with%20city%20view%2C%20three%20bedrooms%20interior%2C%20contemporary%20furniture%2C%20wooden%20flooring%2C%20large%20sliding%20doors%2C%20warm%20natural%20light%2C%20Brazilian%20city%20apartment%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-11&orientation=landscape',
    description: 'Apartamento amplo e bem distribuído no bairro Passo dos Fortes, uma ótima escolha para famílias que desejam conforto em Chapecó. São 110m², com 3 quartos, 2 banheiros e espaços pensados para proporcionar uma rotina agradável. A sacada com churrasqueira cria um ambiente especial para receber amigos e aproveitar a vista panorâmica da cidade. O imóvel possui 1 vaga de garagem e faz parte de um condomínio com academia e piscina, reunindo conveniência e lazer sem sair de casa. Uma oportunidade para quem procura metragem generosa, boa localização e uma estrutura condominial completa para diferentes momentos do dia.',
    type: 'Apartamento',
    purpose: 'Venda',
    city: 'Chapecó',
  },
  {
    id: 12,
    tag: 'LOCAÇÃO',
    location: 'São Miguel do Oeste/SC - Bairro São Cristóvão',
    title: 'Casa para alugar',
    bedrooms: 2,
    bathrooms: 1,
    parking: 1,
    area: 85,
    price: 'R$ 1.800,00/mês',
    priceValue: 1800,
    image: 'https://readdy.ai/api/search-image?query=Charming%20small%20single-story%20house%20with%20green%20lawn%20and%20flower%20garden%2C%20white%20painted%20walls%2C%20blue%20shutters%2C%20residential%20Brazilian%20street%2C%20warm%20sunny%20day%2C%20cozy%20family%20home%2C%20professional%20real%20estate%20photography&width=600&height=400&seq=prop-12&orientation=landscape',
    description: 'Casa charmosa para locação no bairro São Cristóvão, em São Miguel do Oeste, ideal para quem busca um lar prático e acolhedor. Com 85m², possui 2 dormitórios, 1 banheiro e ambientes bem dimensionados para casais ou pequenas famílias. A propriedade conta com 1 vaga de garagem, área de serviço e um quintal com horta, proporcionando mais contato com o verde e possibilidades para aproveitar o espaço externo. Inserida em uma região tranquila e de perfil familiar, oferece uma rotina residencial agradável. Uma boa escolha para morar com simplicidade, conforto e a sensação de ter seu próprio espaço.',
    type: 'Casa',
    purpose: 'Locação',
    city: 'São Miguel do Oeste',
  },
].map((property) => ({ ...property, image: `/property-${property.id}.jpg` }));

export const featuredProperties = allProperties.slice(0, 4);

export const testimonials = [
  {
    id: 1,
    name: 'Maria Silva',
    text: 'Excelente atendimento! A equipe da Bertoncello BNI nos ajudou em todas as etapas da compra do nosso imóvel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'João Carlos Pereira',
    text: 'Profissionais competentes e atenciosos. Encontramos o imóvel ideal para nossa família graças a eles!',
    rating: 5,
  },
  {
    id: 3,
    name: 'Ana Paula Souza',
    text: 'Rapidez e segurança na locação do meu imóvel. Recomendo a Bertoncello BNI!',
    rating: 5,
  },
];

export const services = [
  {
    id: 1,
    icon: 'ri-home-gear-line',
    title: 'COMPRA DE IMÓVEIS',
    description: 'Encontre o imóvel ideal com a orientação certa.',
    link: '/contato',
  },
  {
    id: 2,
    icon: 'ri-file-list-3-line',
    title: 'VENDA DE IMÓVEIS',
    description: 'Divulgamos seu imóvel com estratégia e alcançamos os melhores compradores.',
    link: '/contato',
  },
  {
    id: 3,
    icon: 'ri-key-2-line',
    title: 'LOCAÇÃO DE IMÓVEIS',
    description: 'Alugue com segurança e agilidade. Cuidamos de todo o processo para você.',
    link: '/contato',
  },
  {
    id: 4,
    icon: 'ri-scales-3-line',
    title: 'AVALIAÇÃO DE IMÓVEIS',
    description: 'Avaliação justa e precisa para vender ou alugar com o valor correto do mercado.',
    link: '/contato',
  },
];

export const differentials = [
  {
    id: 1,
    icon: 'ri-award-line',
    title: 'EXPERIÊNCIA E CREDIBILIDADE',
    description: 'Anos de atuação no mercado imobiliário com ética e transparência.',
  },
  {
    id: 2,
    icon: 'ri-map-pin-2-line',
    title: 'CONHECIMENTO DA REGIÃO',
    description: 'Especialistas no Oeste Catarinense, entendemos o que faz valorizar cada lugar.',
  },
  {
    id: 3,
    icon: 'ri-hand-heart-line',
    title: 'ATENDIMENTO PERSONALIZADO',
    description: 'Cada cliente é único. Atendimento próximo, humanizado e focado em resultados.',
  },
  {
    id: 4,
    icon: 'ri-home-smile-line',
    title: 'IMÓVEIS SELECIONADOS',
    description: 'Ofertas cuidadosamente analisadas para garantir segurança e as melhores oportunidades.',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: 'ASSESSORIA COMPLETA',
    description: 'Acompanhamento em todas as etapas do negócio para você comprar, vender ou alugar com tranquilidade.',
  },
];

export const cities = [
  { name: 'Chapecó', icon: 'ri-building-line' },
  { name: 'Xanxerê', icon: 'ri-building-2-line' },
  { name: 'São Miguel do Oeste', icon: 'ri-home-4-line' },
  { name: 'Maravilha', icon: 'ri-community-line' },
  { name: 'Palmitos', icon: 'ri-tree-line' },
  { name: 'E muito mais!', icon: 'ri-map-pin-add-line' },
];
